import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Image,
  Input,
  Link,
  Stack,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Img } from "../../../content/Content";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import './login.component.css'

const Login = () => {
  const [showPass, setShowPass] = useState(false);

  return (
    <div>
      {/* desktop-version */}
      <VStack w="100%" alignItems={"center"} gap="0" flexDir={"row"} className="desktop-version">
        {/* left side */}
        <Stack w="75%" gap="0" h="100vh">
          <Image src={Img.loginBg} alt="loginBg" w="100%" h="auto" />
        </Stack>
        {/* right side */}
        <Stack w="25%" gap="0" position={"relative"} h="100%">
          <Stack px="50px">
            <Stack py="30px">
              <Image src={Img.loginLogo} alt="logo" w="153px" h="28.41px" />
            </Stack>

            <Stack>
              {/*  */}
              <Text
                fontSize="20px"
                fontWeight={"700"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
                color="rgba(26, 26, 26, 1)"
              >
                Welcome to JIFU TV
              </Text>
            </Stack>

            {/* form */}

            <Stack w="100%">
              <FormControl w="100%">
                <FormLabel
                  fontSize="11px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(26, 26, 26, 1)"
                  px="5px"
                >
                  Email{" "}
                </FormLabel>
                <Input
                  type="email"
                  bg="rgba(229, 229, 229, 1)"
                  border="0.5px solid rgba(229, 229, 229, 1)"
                  placeholder="Username or Email Address"
                  w="100%"
                  h="48px"
                  px="25px"
                  borderRadius={"10px"}
                  my="5px"
                  fontSize="15px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Roboto', sans-serif;"}
                  color="rgba(128, 128, 128, 1)"
                  _focusWithin={{
                    border: "0",
                    outline: "none",
                  }}
                />
              </FormControl>

              <FormControl w="100%" position={"relative"}>
                <FormLabel
                  fontSize="11px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(26, 26, 26, 1)"
                  px="5px"
                >
                  Password{" "}
                </FormLabel>
                <Input
                  type={showPass ? "text" : "password"}
                  bg="rgba(229, 229, 229, 1)"
                  border="0.5px solid rgba(229, 229, 229, 1)"
                  placeholder="Enter password"
                  w="100%"
                  h="48px"
                  px="25px"
                  borderRadius={"10px"}
                  my="5px"
                  fontSize="15px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Roboto', sans-serif;"}
                  color="rgba(128, 128, 128, 1)"
                  _focusWithin={{
                    border: "0",
                    outline: "none",
                  }}
                />
                <Box
                  position={"absolute"}
                  right={"10px"}
                  top={"39px"}
                  color="rgba(77, 77, 77, 1)"
                  fontSize={"16px"}
                  cursor="pointer"
                  onClick={() => setShowPass(!showPass)}
                >
                  {showPass ? <AiFillEyeInvisible /> : <AiFillEye />}
                </Box>
              </FormControl>
              <Box
                display="flex"
                py="10px"
                alignItems="center"
                justifyContent="space-between"
                w="100%"
              >
                <FormControl display="flex" alignItems="center">
                  <Switch id="email-alerts" />
                  <FormLabel
                    htmlFor="email-alerts"
                    mx="4px"
                    mb="0"
                    fontSize="12px"
                    fontWeight={"400"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(26, 26, 26, 1)"
                  >
                    Remember me
                  </FormLabel>
                </FormControl>
                <Link
                  w="50%"
                  textAlign={"end"}
                  fontSize="12px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(0, 122, 255, 1)"
                >
                  Forgot password?
                </Link>
              </Box>
              <Button
                fontSize="15px"
                fontWeight={"700"}
                fontFamily={"font-family: 'Roboto', sans-serif;"}
                w="100%"
                textAlign="center"
                bg="rgba(0, 122, 255, 1)"
                h="40px"
                color="#fff"
              >
                Sign in
              </Button>
              {/* do you have account */}
              <Divider mt="35px" />
              <Text
                py="25px"
                textAlign="center"
                fontSize="12px"
                fontWeight={"400"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
                color="rgba(26, 26, 26, 1)"
              >
                Dont have an account?
                <Link
                  fontSize="12px"
                  fontWeight={"400"}
                  mx="2px"
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(0, 122, 255, 1)"
                >
                  Sign up now
                </Link>
              </Text>
            </Stack>
            <Stack position="absolute" bottom="-106px" left={"0"} right="0">
              <Text
                textAlign="center"
                color="rgba(102, 102, 102, 1)"
                fontSize="12px"
                fontWeight={"400"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
              >
                © 2023 JIFU
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </VStack>
    {/* mobile version */}
    <VStack w="100%" alignItems={"center"} gap="0" flexDir={"row"} className="mobile-version">
        {/* left side */}
        {/* right side */}
        <Stack w="100%" gap="0" position={"relative"} h="100%" pt="100px">
          <Stack px="50px">
            <Stack py="30px">
              <Image src={Img.loginLogo} alt="logo" w="153px" h="28.41px" />
            </Stack>

            <Stack>
              {/*  */}
              <Text
                fontSize="20px"
                fontWeight={"700"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
                color="rgba(26, 26, 26, 1)"
              >
                Welcome to JIFU TV
              </Text>
            </Stack>

            {/* form */}

            <Stack w="100%">
              <FormControl w="100%">
                <FormLabel
                  fontSize="11px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(26, 26, 26, 1)"
                  px="5px"
                >
                  Email{" "}
                </FormLabel>
                <Input
                  type="email"
                  bg="rgba(229, 229, 229, 1)"
                  border="0.5px solid rgba(229, 229, 229, 1)"
                  placeholder="Username or Email Address"
                  w="100%"
                  h="48px"
                  px="25px"
                  borderRadius={"10px"}
                  my="5px"
                  fontSize="15px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Roboto', sans-serif;"}
                  color="rgba(128, 128, 128, 1)"
                  _focusWithin={{
                    border: "0",
                    outline: "none",
                  }}
                />
              </FormControl>

              <FormControl w="100%" position={"relative"}>
                <FormLabel
                  fontSize="11px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(26, 26, 26, 1)"
                  px="5px"
                >
                  Password{" "}
                </FormLabel>
                <Input
                  type={showPass ? "text" : "password"}
                  bg="rgba(229, 229, 229, 1)"
                  border="0.5px solid rgba(229, 229, 229, 1)"
                  placeholder="Enter password"
                  w="100%"
                  h="48px"
                  px="25px"
                  borderRadius={"10px"}
                  my="5px"
                  fontSize="15px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Roboto', sans-serif;"}
                  color="rgba(128, 128, 128, 1)"
                  _focusWithin={{
                    border: "0",
                    outline: "none",
                  }}
                />
                <Box
                  position={"absolute"}
                  right={"10px"}
                  top={"39px"}
                  color="rgba(77, 77, 77, 1)"
                  fontSize={"16px"}
                  cursor="pointer"
                  onClick={() => setShowPass(!showPass)}
                >
                  {showPass ? <AiFillEyeInvisible /> : <AiFillEye />}
                </Box>
              </FormControl>
              <Box
                display="flex"
                py="10px"
                alignItems="center"
                justifyContent="space-between"
                w="100%"
              >
                <FormControl display="flex" alignItems="center">
                  <Switch id="email-alerts" />
                  <FormLabel
                    htmlFor="email-alerts"
                    mx="4px"
                    mb="0"
                    fontSize="12px"
                    fontWeight={"400"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(26, 26, 26, 1)"
                  >
                    Remember me
                  </FormLabel>
                </FormControl>
                <Link
                  w="50%"
                  textAlign={"end"}
                  fontSize="12px"
                  fontWeight={"400"}
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(0, 122, 255, 1)"
                >
                  Forgot password?
                </Link>
              </Box>
              <Button
                fontSize="15px"
                fontWeight={"700"}
                fontFamily={"font-family: 'Roboto', sans-serif;"}
                w="100%"
                textAlign="center"
                bg="rgba(0, 122, 255, 1)"
                h="40px"
                color="#fff"
              >
                Sign in
              </Button>
              {/* do you have account */}
              <Divider mt="35px" />
              <Text
                py="25px"
                textAlign="center"
                fontSize="12px"
                fontWeight={"400"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
                color="rgba(26, 26, 26, 1)"
              >
                Dont have an account?
                <Link
                  fontSize="12px"
                  fontWeight={"400"}
                  mx="2px"
                  fontFamily={"font-family: 'Poppins', sans-serif;"}
                  color="rgba(0, 122, 255, 1)"
                >
                  Sign up now
                </Link>
              </Text>
            </Stack>
            <Stack position="absolute" bottom="-106px" left={"0"} right="0">
              <Text
                textAlign="center"
                color="rgba(102, 102, 102, 1)"
                fontSize="12px"
                fontWeight={"400"}
                fontFamily={"font-family: 'Poppins', sans-serif;"}
              >
                © 2023 JIFU
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </VStack>
    </div>
  );
};

export default Login;
